/* Spacezat · ajustes: barra de avisos animada, carrusel de reseñas, filtro de precio con puntos de miles y suscripción */
(function () {
  if (window.__szx) return;
  window.__szx = true;
  var ARROW_L = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var ISO = '<svg viewBox="730 326 111 102" aria-hidden="true"><path fill="#2F0F5A" d="M799.3 423.9C797.8 424.5 796.3 424.7 794.8 424.7C791.3 424.7 787.9 423.2 785.5 420.2L773.2 405.0L754.9 412.0C749.9 413.9 744.5 412.5 741.1 408.3C737.7 404.2 737.4 398.6 740.3 394.1L754.3 373.7C754.3 373.7 759.3 388.9 775.1 393.8C788.7 398.1 803.6 391.6 805.4 390.8L807.0 411.9C807.3 417.3 804.3 422.0 799.3 423.9M803.9 371.8C797.5 372.8 789.8 372.9 781.6 370.6C773.6 368.4 767.5 364.9 762.7 361.2L779.5 336.7C782.4 332.3 787.6 330.3 792.7 331.7C797.9 333.1 801.4 337.4 801.7 342.7L803.9 371.8"/><path fill="#841DFF" d="M832.2 377.2C831.9 377.4 808.7 393.4 777.4 385.0C746.9 376.9 735.7 351.3 735.7 351.1C734.0 347.3 735.8 342.9 739.6 341.3C743.4 339.6 747.8 341.4 749.5 345.2C749.5 345.3 753.2 353.7 762.7 361.2C767.5 364.9 773.6 368.4 781.6 370.6C789.8 372.9 797.5 372.8 803.9 371.8C815.9 369.9 823.9 364.7 823.9 364.7C827.4 362.4 832.0 363.3 834.3 366.8C836.6 370.2 835.7 374.9 832.2 377.2"/></svg>';
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmt(v) { var d = String(v == null ? '' : v).replace(/\D/g, ''); return d ? Number(d).toLocaleString('es-CL') : ''; }
  function digits(v) { return String(v || '').replace(/\D/g, ''); }

  /* ---- barra de avisos: cinta que se desplaza ---- */
  function ticker() {
    var bar = document.querySelector('.store-messages-bar');
    if (!bar || bar.getAttribute('data-sz-tk')) return;
    var parts = [];
    $$('.store-message', bar).forEach(function (m) {
      m.textContent.split('/').forEach(function (t) { t = t.trim(); if (t) parts.push(t); });
    });
    if (!parts.length) return;
    bar.setAttribute('data-sz-tk', '1');
    var one = parts.map(function (t) { return '<span class="sz-tk__item">' + esc(t) + '</span><span class="sz-tk__sep">' + ISO + '</span>'; }).join('');
    var group = '';
    for (var i = 0; i < 4; i++) group += one;
    var tk = document.createElement('div');
    tk.className = 'sz-tk';
    tk.setAttribute('role', 'marquee');
    tk.setAttribute('aria-label', parts.join('. '));
    tk.innerHTML = '<div class="sz-tk__track"><div class="sz-tk__group">' + group + '</div><div class="sz-tk__group" aria-hidden="true">' + group + '</div></div>';
    bar.appendChild(tk);
    bar.classList.add('has-ticker');
  }

  /* ---- reseñas ---- */
  function reviews() {
    var list = document.querySelector('.jdgm-shop-reviews__body');
    if (list && !list.getAttribute('data-sz-nav')) {
      list.setAttribute('data-sz-nav', '1');
      var nav = document.createElement('div');
      nav.className = 'sz-rv-nav';
      nav.innerHTML = '<button type="button" aria-label="Anterior" data-d="-1">' + ARROW_L + '</button><button type="button" aria-label="Siguiente" data-d="1">' + ARROW_R + '</button>';
      list.parentNode.insertBefore(nav, list);
      nav.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        list.scrollBy({ left: parseInt(b.getAttribute('data-d'), 10) * Math.max(300, list.clientWidth * 0.8), behavior: 'smooth' });
      });
    }
    $$('.jdgm-write-rev-link').forEach(function (a) {
      if (a.textContent.trim() === 'Write a review') a.textContent = 'Escribir una reseña';
    });
  }

  /* ---- filtro de precio con separador de miles ---- */
  function prices() {
    $$('.cc-price-range__input').forEach(function (orig) {
      if (orig.getAttribute('data-sz-pr')) return;
      orig.setAttribute('data-sz-pr', '1');
      var view = document.createElement('input');
      view.type = 'text';
      view.setAttribute('inputmode', 'numeric');
      view.autocomplete = 'off';
      view.className = orig.className + ' sz-pr-view';
      view.setAttribute('aria-label', orig.getAttribute('aria-label') || '');
      view.placeholder = fmt(orig.getAttribute('placeholder'));
      view.value = fmt(orig.value);
      orig.style.cssText = 'position:absolute;opacity:0;pointer-events:none;width:1px;height:1px;';
      orig.tabIndex = -1;
      orig.parentNode.insertBefore(view, orig.nextSibling);
      view.addEventListener('input', function () {
        var d = digits(view.value);
        view.value = fmt(d);
        orig.value = d;
        orig.dispatchEvent(new Event('input', { bubbles: true }));
      });
      view.addEventListener('change', function () {
        orig.value = digits(view.value);
        orig.dispatchEvent(new Event('change', { bubbles: true }));
      });
      setInterval(function () {
        if (document.activeElement === view) return;
        var f = fmt(orig.value);
        if (view.value !== f) view.value = f;
        var ph = fmt(orig.getAttribute('placeholder'));
        if (view.placeholder !== ph) view.placeholder = ph;
      }, 400);
    });
  }

  /* ---- suscripción: etiqueta flotante ---- */
  function subscribe() {
    $$('.subscribe-form__email').forEach(function (inp) {
      if (inp.getAttribute('data-sz-sub')) return;
      inp.setAttribute('data-sz-sub', '1');
      var w = inp.closest('.input-wrapper') || inp.parentNode;
      function upd() { if (inp.value) w.setAttribute('data-filled', '1'); else w.removeAttribute('data-filled'); }
      inp.addEventListener('input', upd); inp.addEventListener('change', upd); upd();
    });
  }

  function run() { ticker(); reviews(); prices(); subscribe(); }
  function init() {
    run();
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 150); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
